import React from "react";
import { Search } from "lucide-react";

const PageHeader = ({ 
  searchTerm, 
  setSearchTerm, 
  title = "All Speakers", 
  subtitle = "Professional Directory", 
  placeholder = "Search items...", 
  icon: IconComponent // Menerima komponen ikon sebagai prop
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
      <div>
        <h1 className="text-4xl font-black text-slate-900 dark:text-white flex items-center gap-4">
          {/* Render ikon secara dinamis jika ada */}
          {IconComponent && <IconComponent size={40} className="text-blue-600" />} 
          {title}
        </h1>
        <p className="text-slate-500 dark:text-slate-400 mt-2 text-sm font-medium uppercase tracking-widest">
          {subtitle}
        </p>
      </div>

      <div className="relative w-full md:w-80">
        <Search 
          className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" 
          size={18} 
        />
        <input
          type="text"
          value={searchTerm}
          placeholder={placeholder}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-12 pr-4 py-4 bg-white dark:bg-slate-900 border border-slate-100 dark:border-white/5 rounded-2xl outline-none text-sm shadow-sm focus:ring-2 focus:ring-blue-600/20 transition-all"
        />
      </div>
    </div>
  );
};

export default PageHeader;